import styled from 'styled-components';
import { Persona } from '@fluentui/react';
import { Dismiss16Filled } from '@fluentui/react-icons';

export const TeamWidgetEmployeeContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 485px;
  overflow: auto;
`;

export const TeamWidgetPersonaContainer = styled.ul`
  width: 100%;
  background: ${(props) => props.theme.mainBackgorund};

  li {
    padding: 0.5rem 1.2rem;
    list-style: none;
    background: ${(props) => props.theme.mainBackgorund};
  }

  li:hover {
    background: ${(props) => props.theme.popupVacationHoverBackground};
    cursor: pointer;
  }
`;

export const TeamWidgetPersona = styled(Persona)<{
  backgroundPersonal?: string;
  colorPersona?: string;
}>`
  position: static;
  .ms-Persona-primaryText {
    font-weight: 600;
    font-size: 16px;
    color: ${(props) => props.theme.textMainColor};
    position: static;
  }

  .ms-Persona-initials span {
    font-size: 14px;
    font-weight: 600;
    position: static;
  }
  .ms-Persona-initials {
    background: ${({ backgroundPersonal }) => backgroundPersonal || '#E9C7CD'};
    color: ${({ colorPersona }) => colorPersona || '#420610'};
  }
  .ms-Persona-imageArea {
    position: static !important;
  }
`;

export const TeamWidgetListItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    svg {
      display: block;
    }
  }
`;

export const TeamWidgetListItemDismiss = styled(Dismiss16Filled)`
  display: none;
  &:hover {
    cursor: pointer;
  }
`;
